import { Button, Input, Table } from "antd";
import Column from "antd/lib/table/Column";
import React from "react";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import useServiceCenterStock from "./useServiceCenterStock";

export const ServiceCenterStock = () => {
  const [
    loading,
    state,
    handleChange,
    serviceCenterStocks,
    getServiceCenterStocks,
  ] = useServiceCenterStock();
  return (
    <Loading isLoading={loading}>
      <Header title="موجودی مراکز" activeItem={"serviceCenterStocks"} />
      <div className="mb-20" style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div className="flex-row flex-content-space-between flex-wrap py-10 px-20">
          <Input
            className="input-black border-black w-40 sm:w-100 my-5"
            placeholder="شناسه مرکز"
            value={state.service_center_id}
            onChange={(e) =>
              handleChange({ service_center_id: e.target.value })
            }
          />
          <Input
            className="input-black border-black w-40 sm:w-100 my-5"
            placeholder="شناسه کالا"
            value={state.product_id}
            onChange={(e) => handleChange({ product_id: e.target.value })}
          />
        </div>
        <div className="flex-row sm:w-100 flex-content-center px-20 mb-20">
          <Button
            className="button-secondary w-50 sm:w-100"
            onClick={getServiceCenterStocks}
          >
            فیلتر
          </Button>
        </div>
        <Table
          size="small"
          scroll={{ x: 640 }}
          dataSource={serviceCenterStocks?.stocks ?? []}
          pagination={false}
          //   pagination={{
          //     position: ["bottomCenter"],
          //     current: pagination.page,
          //     pageSize: pagination.limit,
          //     total: pagination.count,
          //     onChange: changePage,
          //   }}
        >
          <Column
            title="مرکز"
            render={() => <span>{serviceCenterStocks?.service_center_name}</span>}
          />
          <Column
            title="محصول"
            dataIndex="product"
            key="product"
            render={(product) => <span>{product?.name}</span>}
          />
          <Column
            title="موجودی کالای امانی"
            dataIndex="carfix_stock"
            key="carfix_stock"
            render={(carfix_stock) => <span>{carfix_stock}</span>}
          />
          <Column
            title="موجودی کالای مرکز"
            dataIndex="carfillo_stock"
            key="carfillo_stock"
            render={(carfillo_stock) => <span>{carfillo_stock}</span>}
          />
        </Table>
        {/* {serviceCenterStocks && (
          <div className="flex-row flex-content-space-around flex-wrap mt-20">
            <div
              className="border-black p-20 flex-row flex-content-space-between flex-wrap"
              style={{ maxWidth: "800px", minWidth: "400px" }}
            >
              <div>
                <strong>موجودی کالای امانی: </strong>
                <span>{serviceCenterStocks.carfix_stock}</span>
              </div>
              <div>
                <strong>موجودی کالای مرکز: </strong>
                <span>{serviceCenterStocks.carfillo_stock}</span>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </Loading>
  );
};
